// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: _wlGAge9eM
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicRadialChartCompanySentiment.module.css"; // plasmic-import: _wlGAge9eM/css
import screenshot13PngFBCyfq1Zsds from "./images/screenshot13Png.png"; // plasmic-import: fB-Cyfq1zsds/picture

createPlasmicElementProxy;

export const PlasmicRadialChartCompanySentiment__VariantProps = new Array();

export const PlasmicRadialChartCompanySentiment__ArgProps = new Array("radial");

const $$ = {};

function PlasmicRadialChartCompanySentiment__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <PlasmicImg__
            alt={""}
            className={classNames(sty.img__cCEnP)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loading={"lazy"}
            src={{
              src: screenshot13PngFBCyfq1Zsds,
              fullWidth: 506,
              fullHeight: 509,
              aspectRatio: undefined
            }}
          />
        ),

        value: args.radial
      })}
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicRadialChartCompanySentiment__ArgProps,
          internalVariantPropNames:
            PlasmicRadialChartCompanySentiment__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicRadialChartCompanySentiment__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicRadialChartCompanySentiment";
  } else {
    func.displayName = `PlasmicRadialChartCompanySentiment.${nodeName}`;
  }
  return func;
}

export const PlasmicRadialChartCompanySentiment = Object.assign(
  // Top-level PlasmicRadialChartCompanySentiment renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicRadialChartCompanySentiment
    internalVariantProps: PlasmicRadialChartCompanySentiment__VariantProps,
    internalArgProps: PlasmicRadialChartCompanySentiment__ArgProps
  }
);

export default PlasmicRadialChartCompanySentiment;
/* prettier-ignore-end */
